export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.ozprixstudios.sistakyerewaa';
export const APP_STORE_URL = 'https://apps.apple.com/gh/app/sistakyerewaa/id6796362164';

const isAppleDevice = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /iPad|iPhone|iPod/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const buildAppUrl = () => {
  return isAppleDevice() ? APP_STORE_URL : GOOGLE_PLAY_URL;
};
